<template>

    <KedvezmenyekBase>

        <v-layout row wrap slot="kedvezmeny" ref="kedvezmeny" style="max-width: 100%;">

            <BnFormField v-if="tobbautoVisible()" :attributes="tobbauto" />

<!--            <BnFormField v-if="facebookVisible()" :attributes="facebook" />-->

            <BnFormField v-if="bankszlaVisible()" :attributes="bankszla" />

            <BnFormField v-if="postaiDKKedvezmenyVisible()" :attributes="podk" />

            <BnFormField :attributes="huseg" />

        </v-layout>

    </KedvezmenyekBase>

</template>

<script>
import BnFormField from '../../../../../../basecomponents/BnFormField.vue';
import Kedvezmeny from '../../../../mixins/dijak/kedvezmenyek/Kedvezmeny';
import KedvezmenyekBase from '../KedvezmenyBase.vue';

export default {
    name: 'KedvezmenyekB9',
    components: {
        KedvezmenyekBase,
        BnFormField,
    },
    mixins: [Kedvezmeny],
    methods: {
        tomegkozlVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        tobbautoVisible() {
            return this.isSZGK() || this.isTeherKisebb3500kg();
        },
        facebookVisible() {
            return this.isSZGK();
        },
        bankszlaVisible() {
            return this.isSZGK();
        },
        postaiDKKedvezmenyVisible() {
            return this.isTermeszetesSzemely()
                && parseInt(this.$store.getters.tarifaData.ajanl_kock_kezd, 10) >= 20220701
                && (this.isSZGK() || this.isTeherKisebb3500kg());
        },
    },
    data() {
        return {
            tobbauto: {
                type: 'checkbox',
                label: 'Családi többautó kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.9.tobbauto',
                mezo: 'posta_tobbauto',
                change: this.shouldRecalc,
            },
            facebook: {
                type: 'checkbox',
                label: 'Facebook kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.9.facebook',
                mezo: 'posta_facebook',
                change: this.shouldRecalc,
            },
            bankszla: {
                type: 'checkbox',
                label: 'Bankszámla kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.9.bankszla',
                mezo: 'posta_bankszla',
                change: this.shouldRecalc,
            },
            tomegkozl: {
                type: 'checkbox',
                label: 'Tömegközlekedési kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.9.tomegkozl',
                mezo: 'post_tomegkozl',
                change: this.shouldRecalc,
            },
            podk: {
                type: 'checkbox',
                label: 'Postai díjkalkulációs kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.9.podk',
                mezo: 'posta_podk',
                change: this.shouldRecalc,
            },
            huseg: {
                type: 'checkbox',
                label: 'Posta hűségkártya kedvezmény',
                visible: true,
                editable: !this.disabled,
                help: true,
                path: 'kedvezmenyekbiztosito.9.huseg',
                mezo: 'post_huseg',
                change: this.shouldRecalc,
            },
        };
    },
};
</script>
